import '@/scss/common/build_common';

import App from '@/app';
import Router from '@/router';
import Store from '@/store';

if ((window as any).__INITIAL_STATE__) {
	Store.replaceState((window as any).__INITIAL_STATE__);
}

Router.onReady((): void => {
	App.$mount('#app');
});
